import Cookies from 'js-cookie';

export const getWhatsappUrl = (productId = null) => {
  let message = '';

  if (productId !== null) {
    message = `${Cookies.get('whatsapp_product_message')} ${window.location.origin}/product/${productId}`;
  } else {
    message = `${Cookies.get('whatsapp_message')}`;
  }

  const encodedMessage = encodeURIComponent(message);
  return `${Cookies.get('whatsapp_link')}?text=${encodedMessage}`;
};
